import sanitizeHtml from 'sanitize-html';
import { classnames } from '@/utils/classnames/classnames';
import { RichTextProps } from './types';

// EWM-198 — sanitized HTML renderer for backend rich-text fields (CT product
// description, content tastics). Distinct from `Atoms/Markdown` which expects
// markdown source and runs it through markdown.toHTML first; this atom takes
// HTML directly.
const sanitizeOptions: sanitizeHtml.IOptions = {
  allowedTags: [
    'p',
    'br',
    'b',
    'strong',
    'i',
    'em',
    'u',
    'ul',
    'ol',
    'li',
    'a',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'div',
    'sup',
    'sub',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  // Force safe link defaults.
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', { target: '_blank', rel: 'noopener noreferrer' }),
  },
};

const RichText = ({ html, className }: RichTextProps) => {
  if (!html) return null;
  const sanitized = sanitizeHtml(html, sanitizeOptions);
  return (
    <div
      className={classnames(
        'text-15 prose prose-sm [&_a]:text-primary max-w-none leading-relaxed text-gray-700 [&_a]:underline [&_b]:font-semibold [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:mb-3 [&_p:last-child]:mb-0 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default RichText;
